export default __webpack_public_path__ + "static/media/LU.51365896.svg";